import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
    state: () => ({
        isMobileMenuOpen: false,
        isDesktopMenuVisible: true,
        theme: 'light',
    }),
    actions: {
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        },
        closeMobileMenu() {
            this.isMobileMenuOpen = false;
        },
        openMobileMenu() {
            this.isMobileMenuOpen = true;
        },
        toggleDesktopMenu() {
            this.isDesktopMenuVisible = !this.isDesktopMenuVisible;
        },
        toggleTheme() {
            // Theme toggle disabled for now as per redesign
            this.theme = 'light';
            this.applyTheme();
        },
        initTheme() {
            this.applyTheme();
        },
        applyTheme() {
            localStorage.setItem('theme', 'light');
            document.documentElement.classList.remove('dark');
        }
    },
});
